export default "__VITE_ASSET__DiflyoGI__"